import type { Fragment, Node } from '@tiptap/pm/model';
import type { Editor } from '@tiptap/react';

export function getTextFromSelection(editor: Editor) {
  const { from, to, empty } = editor.state.selection;

  if (empty) {
    return null;
  }

  return editor.state.doc.textBetween(from, to, ' ');
}

export function isTableCellBgActive(editor: Editor, color: string | null) {
  const { state } = editor;
  const { selection } = state;
  let cell = null;
  // This loop begins at the current selection and works its way up
  // through the parent nodes until it finds a table cell.
  for (let depth = selection.$from.depth; depth > 0; depth--) {
    const node = selection.$from.node(depth);

    if (node.type.name === 'tableCell') {
      cell = node;
      break;
    }
  }
  if (!cell) return false;

  return (cell.attrs.backgroundColor ?? null) === color;
}

export function getLinkFromSelection(editor: Editor) {
  const cursorPosition = editor.state.selection.$anchor.pos;
  const node = editor.state.doc.nodeAt(cursorPosition);
  if (!node) return null;

  const link = node.marks.find((mark) => mark.type.name === 'link');
  if (!link) return null;

  return {
    text: node.textContent,
    attrs: link.attrs,
  };
}

export function getTableCellsFromSelection(editor: Editor): Node[] {
  const { selection } = editor.state;
  const tableCells: Node[] = [];

  // using a recursive search as content can have nested child content
  function traverseContent(content: Fragment) {
    for (const node of content.content) {
      if (node.type.name === 'tableCell') {
        tableCells.push(node);
        continue;
      }
      if (node.content.content?.length) {
        traverseContent(node.content);
      }
    }
  }

  traverseContent(selection.content().content);

  return tableCells;
}
